module.exports = __webpack_public_path__ + "static/media/imgNosotros1.7b4e4d59.png";